module.exports = __webpack_public_path__ + "media/images/mailer/confirmation_email_01-ad4ceca74b2098286c5bc23987e2f656.png";